module.exports = __webpack_public_path__ + "static/media/people.ab8f7f1d.svg";